import React from "react";

const EducationView = (data) => {
  return (
    <div>
      <h1 className="text-xl mb-4 font-bold">Education</h1>
      {data?.data?.map((eachEducation, index) => {
        return (
          <div
            key={index}
            className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10 bg-neutral-100 p-4 rounded-sm"
          >
            <div>
              <h3 className="font-semibold text-lg text-gray-900">School</h3>
              <p className="text-gray-500 text-sm mt-1">
                {eachEducation?.school || "No school specified"}
              </p>
            </div>
            <div>
              <h3 className="font-semibold text-lg text-gray-900">Course</h3>
              <p className="text-gray-500 text-sm mt-1">
                {eachEducation?.course || "No course specified"}
              </p>
            </div>
            <div>
              <h3 className="font-semibold text-lg text-gray-900">
                Certificate
              </h3>
              <p className="text-gray-500 text-sm mt-1">
                {eachEducation?.certificate || "No certificate specified"}
              </p>
            </div>
            <div>
              <h3 className="font-semibold text-lg text-gray-900">grade</h3>
              <p className="text-gray-500 text-sm mt-1">
                {eachEducation?.gpa || "No grade specified"}
              </p>
            </div>
            <div>
              <h3 className="font-semibold text-lg text-gray-900">From</h3>
              <p className="text-gray-500 text-sm mt-1">
                {eachEducation?.startYear || "No year specified"}
              </p>
            </div>
            <div>
              <h3 className="font-semibold text-lg text-gray-900">To</h3>
              <p className="text-gray-500 text-sm mt-1">
                {eachEducation?.finishYear || "No year specified"}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default EducationView;
